export const PREFIX = ['conversations', 'message'];
export function getMessageQueryKey(context, query) {
    return [...PREFIX, context.principal?.id, query.thread.id];
}
//# sourceMappingURL=conversationMessageHelper.js.map